import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialIcons = [
    { name: 'Facebook', icon: '📘', link: '#' },
    { name: 'Twitter', icon: '🐦', link: '#' },
    { name: 'Instagram', icon: '📸', link: '#' },
    { name: 'LinkedIn', icon: '💼', link: '#' },
  ];

  const footerLinks = [
    { name: 'Confidentialité', link: '#' },
    { name: 'Conditions d\'utilisation', link: '#' },
    { name: 'Mentions légales', link: '#' },
    { name: 'Accessibilité', link: '#' },
  ];

  const iconVariants = {
    hover: {
      scale: 1.2,
      rotate: 5,
      transition: { duration: 0.3 }
    }
  };

  const linkVariants = {
    hover: {
      scale: 1.05,
      color: '#00AEEF',
      transition: { duration: 0.2 }
    }
  };

  return (
    <footer id="contact" className="bg-[#001233] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold mb-4">MultiLingua</h3>
            <p className="text-gray-300 mb-4">
              Découvrez la beauté des langues du monde entier et connectez-vous avec différentes cultures grâce à notre application multilingue interactive.
            </p>
            <div className="flex space-x-4">
              {socialIcons.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.link}
                  aria-label={social.name}
                  variants={iconVariants}
                  whileHover="hover"
                  className="text-2xl hover:text-[#00AEEF] transition-colors"
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="md:col-span-2"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-4">Liens rapides</h3>
                <ul className="space-y-2">
                  {footerLinks.map((link, index) => (
                    <motion.li key={index} variants={linkVariants} whileHover="hover">
                      <a href={link.link} className="text-gray-300 hover:text-white transition-colors">
                        {link.name}
                      </a>
                    </motion.li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-4">Contact</h3>
                <address className="not-italic text-gray-300">
                  <p className="mb-2">123 Avenue des Langues</p>
                  <p className="mb-2">75001 Paris, France</p>
                  <p className="mb-2">
                    <a href="mailto:contact@multilingua.fr" className="hover:text-[#00AEEF] transition-colors">
                      contact@multilingua.fr
                    </a>
                  </p>
                  <p>
                    <a href="tel:+33123456789" className="hover:text-[#00AEEF] transition-colors">
                      +33 1 23 45 67 89
                    </a>
                  </p>
                </address>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>© {currentYear} MultiLingua. Tous droits réservés.</p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
